<template>
  <router-view />
</template>

<script>
export default {
  name: "app-roles"
};
</script>

<style lang="scss" scoped></style>
